module.exports = __webpack_public_path__ + "img/vehiclearancione.4216970b.png";